import { IS_LOADING } from '@/store/types/root/actions-types';
import { REDEEM_CREATE_REQUEST, REDEEM_UPDATE_REQUEST, REDEEM_DELETE_REQUEST, GET_REDEEMS_REQUEST, GET_ADMIN_REDEEMS_REQUEST, REDEEM_ADMIN_UPDATE_REQUEST } from './action-types';
import {ADD_REDEEMS_REQUEST_TO_LIST, ADD_REDEEM_REQUEST_TO_LIST, DELETE_REDEEM_REQUEST_FROM_LIST, UPDATE_REDEEM_REQUEST_IN_LIST} from "./mutation-types"
import api from "@/api/api"
import { SUBTRACT_REDEEM_REQUEST_FROM_MY_WALLET_POINTS } from '../points/mutation-types';
import { POINTS_MODULE_NAME } from '@/store/module-names';
import store from '@/store';

export default {

    [GET_ADMIN_REDEEMS_REQUEST]: async ({  commit })=>{
        let response = {}
        try {
            response =   await api.get("/admin/redeem-request")
            if(response.data.statusCode === 200){
                const reponseBody = response.data.body
                reponseBody.forEach(element => {
                    element.date = element.created_at.split(",")[0]
                    element.name = element.requested_by_user.first_name + " " + element.requested_by_user.last_name
                    if(element.status === "PENDING" || element.status === "IN_PROGRESS"){
                        element.can_modify = true
                    }
                });
                commit(ADD_REDEEMS_REQUEST_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },
    [GET_REDEEMS_REQUEST]: async ({  commit })=>{
        let response = {}
        try {
            response =   await api.get("/redeem-request")
            if(response.data.statusCode === 200){
                const reponseBody = response.data.body
                reponseBody.forEach(element => {
                    element.date = element.created_at.split(",")[0]
                    if(element.status === "PENDING"){
                        element.can_modify = true
                    }
                });
                commit(ADD_REDEEMS_REQUEST_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [REDEEM_CREATE_REQUEST]: async ({ commit }, body)=>{
        let response = {}
        if(body.id)
            delete body.id
            
        if(body.default_points == 0)
            delete body.default_points
        try {
            response =   await api.post("/redeem-request", body)
            const reponseBody = response.data.body
            if(response.data.statusCode === 200){
                store.commit(POINTS_MODULE_NAME + "/" + SUBTRACT_REDEEM_REQUEST_FROM_MY_WALLET_POINTS, {operation:"SUBTRACT", points:reponseBody.points}, { root: false })
                reponseBody.date = reponseBody.created_at.split(",")[0]
                if(reponseBody.status === "PENDING"){
                    reponseBody.can_modify = true
                }
                commit(ADD_REDEEM_REQUEST_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [REDEEM_ADMIN_UPDATE_REQUEST]: async ({state, commit }, body)=>{
        let response = {}
        try{
            response =   await api.put("/admin/redeem-request/", body)
            const responseBody = response.data.body
            if(response.data.statusCode === 200){
                responseBody.date = responseBody.created_at.split(",")[0]
                commit(UPDATE_REDEEM_REQUEST_IN_LIST, {...responseBody})

            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },


    [REDEEM_UPDATE_REQUEST]: async ({state, commit }, body)=>{
        let response = {}
        try{
            response =   await api.put("redeem-request", body)
            const responseBody = response.data.body
            if(response.data.statusCode === 200){
                responseBody.date = responseBody.created_at.split(",")[0]
                commit(UPDATE_REDEEM_REQUEST_IN_LIST, {...responseBody, can_modify: true})
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },
    [REDEEM_DELETE_REQUEST]: async ({ commit }, redeemIDs)=>{
        let response = {}
        try {
            response =   await api.post("/delete-redeem", {id: redeemIDs[0]})
            const reponseBody = response.data.body
            if(response.data.statusCode === 200){
                store.commit(POINTS_MODULE_NAME + "/" + SUBTRACT_REDEEM_REQUEST_FROM_MY_WALLET_POINTS, {operation:"ADD", points:reponseBody.points}, { root: false })
                 commit(DELETE_REDEEM_REQUEST_FROM_LIST, redeemIDs[0])
            }

        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    }

}
